/**
 * Module dependencies.
 */

import { BaseModal } from 'src/components/core/modal/base-modal';
import { StyledButton } from './service-payment';
import { Svg } from 'src/components/core/svg';
import { Text } from 'src/components/core/text';
import { useSchedule } from 'src/providers/schedule';
import { useTranslation } from 'next-i18next';
import discountSvg from 'src/assets/svgs/discount.svg';

/**
 * `DiscountModalProps` type.
 */

type DiscountModalProps = {
  handlePayLater: () => void;
  handlePayNow: () => void;
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Export `DiscountModal` component.
 */

export const DiscountModal = ({ handlePayLater, handlePayNow, isOpen, onClose }: DiscountModalProps) => {
  const { t } = useTranslation('schedule');
  const { isSantanderFlow } = useSchedule();

  const titleKey = isSantanderFlow ? 'messages.discountModal.santander.title' : 'messages.discountModal.title';

  const descriptionKey = isSantanderFlow
    ? 'messages.discountModal.santander.description'
    : 'messages.discountModal.description';

  const primaryLabelKey = isSantanderFlow
    ? 'messages.discountModal.santander.actions.payLater'
    : 'messages.discountModal.actions.payNow';

  const ghostLabelKey = isSantanderFlow
    ? 'messages.discountModal.santander.actions.payNow'
    : 'messages.discountModal.actions.payLater';

  const primaryHandler = isSantanderFlow ? handlePayLater : handlePayNow;
  const ghostHandler = isSantanderFlow ? handlePayNow : handlePayLater;

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} showCloseButton>
      <Svg
        color={'var(--color-primary)'}
        icon={discountSvg}
        size={'38px'}
        style={{ marginBottom: 'var(--space-sm)' }}
      />

      <Text style={{ marginBottom: 'var(--space-xxs)', textAlign: 'center' }} variant={'titleL'} weight={600}>
        {t(titleKey)}
      </Text>

      <Text
        as={'p'}
        style={{
          color: 'var(--color-slate300)',
          margin: '0 auto',
          marginBottom: 'var(--space-xxs)',
          maxWidth: '30ch',
          textAlign: 'center'
        }}
        variant={'bodyS'}
      >
        {t(descriptionKey)}
      </Text>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-xxs)',
          marginTop: 'var(--space-sm)',
          width: '100%'
        }}
      >
        <StyledButton aria-label={t(primaryLabelKey)} onClick={primaryHandler} size={'medium'} stretch>
          {t(primaryLabelKey)}
        </StyledButton>

        <StyledButton aria-label={t(ghostLabelKey)} colorTheme={'ghost'} onClick={ghostHandler} size={'medium'} stretch>
          {t(ghostLabelKey)}
        </StyledButton>
      </div>
    </BaseModal>
  );
};
